import { useSelector } from '@ecommerce/nest-ssr/common';
import { AdsConfigInterface } from 'modules/ads-module/ads-config.interface';

export const useAds = (): AdsConfigInterface => useSelector((state: { ads: AdsConfigInterface; }) => state.ads);
